import { createFileRoute } from '@tanstack/react-router';
import { RelatorioVendaVendasVendedor } from '@/features/relatorio/page/venda/vendas-vendedor/RelatorioVendaVendasVendedor';

export const Route = createFileRoute('/a/relatorio/venda/vendas-vendedor')({
    component: RelatorioVendaVendasVendedor,
});
